const resourceFileRegex = /(\w+)\.(\w{2}(-\w{2})?).json/

export interface ResourceFile {
  ns: string
  lng: string
  content: { [key: string]: any }
}

export function requireResourceFiles(
  requireContext: __WebpackModuleApi.RequireContext
) {
  const resourceFiles = requireContext
    .keys()
    .map((relativePath) => {
      const match = relativePath.match(resourceFileRegex)

      if (match) {
        const [, ns, lng] = match

        return {
          ns,
          lng,
          content: requireContext(relativePath),
        } as ResourceFile
      }

      if (process.env.NODE_ENV !== 'development') {
        // tslint:disable-next-line:no-console
        console.warn(
          `18next: Locale file with invalid name found: '${relativePath}'. Use '<namespace>.<lang>.json' as filename.`
        )
      }

      return null
    })
    .filter((x) => x !== null) as ResourceFile[]

  return resourceFiles
}
